import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * Input component
 * @param {React.InputHTMLAttributes<HTMLInputElement>} props
 * @returns {JSX.Element}
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Apple-like polish (F-7 addendum): control default is 40px.
        'flex h-10 w-full rounded-control border border-line-2 bg-surface px-3 text-body text-ink',
        'max-sm:min-h-11 max-sm:text-base [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:text-base',
        'file:border-0 file:bg-transparent file:text-body file:font-medium placeholder:text-ink-placeholder',
        'aria-invalid:border-danger-solid aria-invalid:ring-danger-solid/30',
        'transition-colors duration-150 ease-out',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-surface',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = 'Input'

export { Input }
